import React from 'react';

export const TrustedPartners = React.lazy(() =>
  import('./TrustedPartners').then((m) => ({
    default: m.TrustedPartners,
  })),
);
